import { DEFAULT_MEDIA_QUERY_SIZES } from 'common/constants';
import { convertPxToVw } from 'utils/helpers';

export const DEFAULT_ICON_NAME = 'star';

const DEFAULT_ICON_SIZE = convertPxToVw(32, 1, DEFAULT_MEDIA_QUERY_SIZES.desktop.min);

export const ICON_STYLE_DEFAULTS = {
	width: DEFAULT_ICON_SIZE,
	height: DEFAULT_ICON_SIZE,
	color: 'rgba(0,0,0,1)',
	strokeWidth: '1',
} as const;
